"use client";

import Link from "next/link";
import Image from "next/image";
import { useSession } from "next-auth/react";
import { UserRoundIcon } from "lucide-react";

export function SiteHeader() {
  const { data: session } = useSession();
  const role = session?.user.role;

  const accountHref = role === "USER" ? "/mi-cuenta" : "/cuenta/login";
  const accountLabel = role === "USER" ? session!.user.name : "Mi cuenta";

  const orgHref = role === "ADMIN" ? "/admin" : role === "ORGANIZER" ? "/panel" : "/login";
  const orgLabel = role === "ADMIN" ? "Panel de administración" : role === "ORGANIZER" ? "Mi organización" : "Acceso organizaciones";

  return (
    <header className="border-b border-border bg-card/90 backdrop-blur">
      <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-4 px-4 py-4 sm:px-6">
        <Link href="/" className="flex items-center">
          <Image
            src="/logo-cropped.png"
            alt="Cultap"
            width={92}
            height={109}
            className="h-16 w-auto sm:h-20"
            priority
          />
        </Link>

        <p className="hidden max-w-sm text-right text-sm text-muted-foreground md:block">
          Toda la agenda literaria y cultural — librerías, universidades y festivales, en un solo
          sitio.
        </p>

        <nav className="flex items-center gap-2 text-sm">
          <Link
            href={accountHref}
            className="flex items-center gap-1.5 rounded-full border border-border px-4 py-1.5 font-medium text-foreground hover:bg-muted"
          >
            {role === "USER" && <UserRoundIcon className="size-3.5" />}
            {accountLabel}
          </Link>
          <Link
            href={orgHref}
            className="rounded-full bg-primary px-4 py-1.5 font-medium text-primary-foreground hover:bg-primary/90"
          >
            {orgLabel}
          </Link>
        </nav>
      </div>
    </header>
  );
}
